export const iris = {
  1: { value: { base: '{colors.iris.light.1}', _dark: '{colors.iris.dark.1}' } },
  2: { value: { base: '{colors.iris.light.2}', _dark: '{colors.iris.dark.2}' } },
  3: { value: { base: '{colors.iris.light.3}', _dark: '{colors.iris.dark.3}' } },
  4: { value: { base: '{colors.iris.light.4}', _dark: '{colors.iris.dark.4}' } },
  5: { value: { base: '{colors.iris.light.5}', _dark: '{colors.iris.dark.5}' } },
  6: { value: { base: '{colors.iris.light.6}', _dark: '{colors.iris.dark.6}' } },
  7: { value: { base: '{colors.iris.light.7}', _dark: '{colors.iris.dark.7}' } },
  8: { value: { base: '{colors.iris.light.8}', _dark: '{colors.iris.dark.8}' } },
  9: { value: { base: '{colors.iris.light.9}', _dark: '{colors.iris.dark.9}' } },
  10: { value: { base: '{colors.iris.light.10}', _dark: '{colors.iris.dark.10}' } },
  11: { value: { base: '{colors.iris.light.11}', _dark: '{colors.iris.dark.11}' } },
  12: { value: { base: '{colors.iris.light.12}', _dark: '{colors.iris.dark.12}' } },
  a1: { value: { base: '{colors.iris.light.a1}', _dark: '{colors.iris.dark.a1}' } },
  a2: { value: { base: '{colors.iris.light.a2}', _dark: '{colors.iris.dark.a2}' } },
  a3: { value: { base: '{colors.iris.light.a3}', _dark: '{colors.iris.dark.a3}' } },
  a4: { value: { base: '{colors.iris.light.a4}', _dark: '{colors.iris.dark.a4}' } },
  a5: { value: { base: '{colors.iris.light.a5}', _dark: '{colors.iris.dark.a5}' } },
  a6: { value: { base: '{colors.iris.light.a6}', _dark: '{colors.iris.dark.a6}' } },
  a7: { value: { base: '{colors.iris.light.a7}', _dark: '{colors.iris.dark.a7}' } },
  a8: { value: { base: '{colors.iris.light.a8}', _dark: '{colors.iris.dark.a8}' } },
  a9: { value: { base: '{colors.iris.light.a9}', _dark: '{colors.iris.dark.a9}' } },
  a10: { value: { base: '{colors.iris.light.a10}', _dark: '{colors.iris.dark.a10}' } },
  a11: { value: { base: '{colors.iris.light.a11}', _dark: '{colors.iris.dark.a11}' } },
  a12: { value: { base: '{colors.iris.light.a12}', _dark: '{colors.iris.dark.a12}' } },
}
